/* unplugin-vue-components disabled */import { render } from "./shici.vue?vue&type=template&id=7d0006a7"
import script from "./shici.vue?vue&type=script&lang=js"
export * from "./shici.vue?vue&type=script&lang=js"

import "./shici.vue?vue&type=style&index=0&id=7d0006a7&lang=css"

import exportComponent from "D:\\code\\vue\\hello_world\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__